var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.5,
    y: 447.5,
    width: 732,
    height: 242
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M759,455v227H42v-227h717M774,440H27v257h747v-257h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27,
    y: 342,
    width: 747,
    height: 18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -2.8,
    y: 216.8,
    width: 441.5,
    height: 7,
    transform: "translate(-86.2 160.9) rotate(-34.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 576.5,
    y: -0.5,
    width: 7,
    height: 441.5,
    transform: "translate(71.4 575.6) rotate(-55.7)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.6,116.2c-5.7,0-13-3.3-18.7-8.3-5.6-5-9.2-11.2-9.3-16.2-.2-7.8,2.6-13.3,7.3-18.8-3.1,6.5-3.8,12.8-2.2,18.6,1.7,6.1,6.2,11.3,12.7,14.8,4.2,2.3,8.6,3.4,12.9,3.4s4.4-.3,6.5-1c5.5-1.8,10-5.4,13.2-10.4,0,6-2.2,10.3-6.7,13.4-4,2.8-9.7,4.4-15.3,4.4h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.7,18.4c-8.1,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6,14.6-6.5,14.6-14.6-6.5-14.6-14.6-14.6h0ZM402.7,40.6c-4.2,0-7.6-3.4-7.6-7.6s3.4-7.6,7.6-7.6,7.6,3.4,7.6,7.6-3.4,7.6-7.6,7.6h0ZM402.7,29.5c-1.9,0-3.5,1.5-3.5,3.5s1.5,3.5,3.5,3.5,3.5-1.5,3.5-3.5-1.5-3.5-3.5-3.5h0ZM392.2,48.5c-.9,2.1-2.2,4-3.8,5.9-2.7,3.1-6.2,6.2-9.5,9.6-6.7,6.8-13,14.8-12.8,27.8.1,7.6,4.9,15.6,11.8,21.7,6.9,6.1,15.8,10.1,23.5,10.2.2,0,.3,0,.5,0,6.6,0,14-1.8,19.7-5.8,5.8-4.1,9.9-10.3,9.9-19.8,0-3.9-2.4-10-3.5-15.6-.5-2.8-.8-5.5.3-8,.9-2.2,2.9-4,5.8-4.8.7-1.7.5-2.6,0-3.2-.6-.7-1.9-1.3-3.7-1.3,0,0,0,0,0,0-1.8,0-3.7.7-5.2,1.9-1.4,1.2-2.4,3-2.4,5.7,0,6.5-.8,12.7-3,17.8-2.2,5.2-5.9,9.3-11.2,11.1-1.3.4-2.7.6-4.2.6-3.2,0-6.4-1-9.3-2.5-4.2-2.3-7.8-5.8-9-10.2-1.4-5,0-10,2.3-14.7,2.4-4.7,6-9.1,9.8-13.3,3.5-3.9,7.1-7.5,9.9-10.7-1.7.5-3.5.8-5.3.8-3.9,0-7.5-1.2-10.5-3.2h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenRoof);
export default __webpack_public_path__ + "static/media/open-roof.6bc9218aa283f3ed75ebabd085d0c6b1.svg";
export { ForwardRef as ReactComponent };